<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { PRESENTER_VALUE_FALLBACK } from '@satellite/components/elements/presenters/presenterValueFallback';
import { useYardAssetVisitDisplay } from '@satellite/composables/useYardAssetVisitDisplay';

import type { YardAssetVisitDetails } from '@satellite/composables/yardAssetVisitPresenterShared';

const props = defineProps<{
  assetVisit: YardAssetVisitDetails | null;
}>();

const { t } = useI18n();

const visit = computed(() => props.assetVisit);
const display = useYardAssetVisitDisplay(visit, {});
const carrierCompany = computed(() => display.companyName ?? PRESENTER_VALUE_FALLBACK);
const visitType = computed(() => display.visitTypeChipText ?? PRESENTER_VALUE_FALLBACK);
</script>

<template>
  <div class="d-flex flex-column gap-3">
    <span class="text-overline text-high-emphasis">
      {{ t('checkSpotPanel.sections.carrierVisit') }}
    </span>
    <v-card variant="flat" border data-testid="check-spot-panel-occupied-carrier">
      <v-card-text class="d-flex flex-column gap-1">
        <span class="typography-body-sm-bold">{{ t('checkSpotPanel.labels.carrierCompany') }}</span>
        <span class="typography-body-sm text-medium-emphasis">{{ carrierCompany }}</span>
      </v-card-text>
    </v-card>
    <v-card variant="flat" border data-testid="check-spot-panel-occupied-visit">
      <v-card-text class="d-flex flex-column gap-1">
        <span class="typography-body-sm-bold">{{ t('checkSpotPanel.labels.visitType') }}</span>
        <span class="typography-body-sm text-medium-emphasis">{{ visitType }}</span>
      </v-card-text>
    </v-card>
  </div>
</template>
